import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Header } from "./components/Header";
import Landing from "./pages/Landing";
import Ask from "./pages/Oracle";
import Tools from "./pages/Tools";
import History from "./pages/History";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import AuthCallback from "./pages/AuthCallback";
import { captureReferralFromUrl } from "./lib/referral";

const TOASTER_OPTIONS = {
  style: {
    background: "#141419",
    color: "#FDFBF7",
    border: "1px solid rgba(212,175,55,0.25)",
  },
};

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center">
        <svg className="glyph-loader" width="50" height="50" viewBox="0 0 50 50" fill="none">
          <circle cx="25" cy="25" r="21" stroke="#D4AF37" strokeWidth="1" strokeDasharray="3 5" />
          <circle cx="25" cy="25" r="3" fill="#D4AF37" />
        </svg>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  // Capture ?ref=CODE into localStorage on first page load — survives OAuth roundtrip.
  useEffect(() => {
    captureReferralFromUrl();
  }, []);
  // Synchronously handle OAuth callback before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/ask" element={<Protected><Ask /></Protected>} />
        <Route path="/tools" element={<Protected><Tools /></Protected>} />
        <Route path="/history" element={<Protected><History /></Protected>} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" toastOptions={TOASTER_OPTIONS} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
